import { Injectable, Optional } from '@angular/core';
import { Observable, of, empty, EMPTY } from 'rxjs';
import { tap, switchMap, concatMap } from 'rxjs/operators';
import { Entity, FrameContext, FieldMetadataUtil } from '@farris/devkit';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { FormNotifyService } from '../form-notify.service';
import { LanguageService } from '../languag.service';
import { FormMessageService } from '../form-message.service';
import { FormErrorService } from '../error/form-error.service';
import { BaseDataService } from './base-data.service';
import { TreeUtilFactory } from './tree-table/util/tree-util-factory';
import { TreeRepositoryFactory } from './tree-table/repository/tree-repository-factory';
import { DataChangeDetectionService } from '../data-change-detection.service';
// tslint:disable: no-string-literal

/**
 * æ æ°æ®æå¡
 */
@Injectable()
class TreeDataService extends BaseDataService {
  /**
   * åçº§ä¿¡æ¯å­æ®µå
   */
  private get hierarchyInfoKey(): string {
    return this.virtualRootFrameContext.getParam('hierarchyInfoKey');
  }
  private get virtualRootFrameContext() {
    return this.frameContext.getVirtualRootFrameContext();
  }

  /**
   * æé å½æ°
   */
  constructor(
    frameContext: FrameContext,
    private messageService: FormMessageService,
    private loadingService: FormLoadingService,
    private notifyService: FormNotifyService,
    private errorService: FormErrorService,
    @Optional() private languageService: LanguageService
  ) {
    super(frameContext);
    if (!languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }

  /**
   * å è½½æ°æ®
   */
  public load(filters?: string, sorts?: string, hierarchyInfoKey?: string): Observable<Entity[]> {
    const filtersArray = this.parseConditions(filters);
    const sortsArray = this.parseConditions(sorts);
    const correctSelectedNode = this.repository.entityCollection.count() === 0;

    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const query$ = this.repository.getEntities(filtersArray, sortsArray, null, null);
    return query$.pipe(
      tap(
        () => {
          // çº æ­£éä¸­èç¹
          if (correctSelectedNode === true) {
            const hierarchyType = this.getHierarchyType(this.hierarchyInfoKey || hierarchyInfoKey);
            const treeNodeUtil = TreeUtilFactory.getInstance(hierarchyType);
            if (treeNodeUtil !== null) {
              treeNodeUtil.selectFirstRootNode(this.bindingData, this.hierarchyInfoKey || hierarchyInfoKey);
            }
          }

          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.loadFailed, error);
        }
      )
    );
  }

  /**
   * åå±å è½½æ°æ®
   */
  public loadByLevel(filters?: string, sorts?: string, frozenCurrentRow?: boolean | string): Observable<Entity[]> {
    this.setLoadByLevelState(filters, sorts);
    const filtersArray = this.parseConditions(filters);
    const sortsArray = this.parseConditions(sorts);
    // const parentId = this.bindingData.list.currentId;
    const parentId = this.getIdToExpand();
    const correctSelectedNode = this.repository.entityCollection.count() === 0;
    if (frozenCurrentRow === undefined) {
      frozenCurrentRow = false;
    }
    if (typeof frozenCurrentRow !== 'boolean') {
      frozenCurrentRow = frozenCurrentRow === 'true' ? true : false;
    }
    const hierarchyType = this.getHierarchyType();
    const repository = TreeRepositoryFactory.getInstance(hierarchyType);

    if (repository === null) {
      return empty();
    }
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    // æé åé¡µä¿¡æ¯
    const pagination = this.buildPaginationInfo(parentId);
    const reload = this.frameContext.params.get('_RELOAD_CHILDREN_') || false;
    const query$ = repository.loadByParentId(this.repository, this.hierarchyInfoKey, parentId, filtersArray, sortsArray, frozenCurrentRow, pagination, this.frameContext, reload);
    return query$.pipe(
      tap(
        (entities: Entity[]) => {
          this.frameContext.params.delete('_RELOAD_CHILDREN_');
          // çº æ­£éä¸­èç¹
          if (correctSelectedNode === true) {
            const treeNodeUtil = TreeUtilFactory.getInstance(hierarchyType);
            if (treeNodeUtil !== null) {
              treeNodeUtil.selectFirstRootNode(this.bindingData, this.hierarchyInfoKey);
            }
          }
          const currentRowId = this.bindingData.list.currentItem.primaryKeyValue;
          if (frozenCurrentRow) {
            // å¦æä¸ä¸æ¬¡éä¸­è¡ä¸ºæ¬æ¬¡å è½½æ°æ®ä¸­çä¸æ¡ï¼ååºè¯¥éæ°éä¸­è¯¥è¡
            const containsCurrentRow = entities.find(item => item.primaryValue === currentRowId);
            if (containsCurrentRow) {
              this.setCurrentId(currentRowId);
            }
            // åæ¥çå½åè¡ä¸å¨å·²ç»å è½½çæ°æ®ä¸­ï¼å¦å±å¼å°ç¬¬ä¸çº§ï¼å°ç¬¬ä¸çº§çæè¡è®¾ä¸ºå½åè¡ï¼å¨é¨æ¶èµ·ï¼å±å¼ç¬¬ä¸çº§
            if (!this.repository.entityCollection.getEntityById(currentRowId)) {
              const firstChildId = entities && Array.isArray(entities) && entities.length > 0 && entities[0].primaryValue || null;
              if (firstChildId) {
                this.setCurrentId(firstChildId);
              }
            }
          }
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.loadFailed, error);
        }
      )
    );
  }
  /**
   * å è½½å®æ´æ 
   * @param virtualPropertyName èæå­æ®µ
   * @param fullTreeType æ¯å¦æ¯å®æ´æ å è½½ 0ï¼å®æ´æ  1ï¼é¨åæ 
   * @param loadType æ¯å¦åçº§å è½½ 0ï¼å¨é¨å è½½ 1ï¼åçº§å è½½
   * @param filter è¿æ»¤æ¡ä»¶
   * @param frozenCurrentRow å»ç»å½åè¡
   */
  public loadFullTree(virtualPropertyName: string, fullTreeType: string, loadType: string, filters: string, frozenCurrentRow?: boolean | string): Observable<Entity[]> {
    if (typeof fullTreeType !== 'string') {
      throw new Error('ArgumentError: fullTreeType ä¸è½ä¸ºç©ºä¸å¿é¡»ä¸ºå­ç¬¦ä¸²ã');
    }
    if (typeof loadType !== 'string') {
      throw new Error('ArgumentError: loadType ä¸è½ä¸ºç©ºä¸å¿é¡»ä¸ºå­ç¬¦ä¸²ã');
    }
    if (frozenCurrentRow === undefined) {
      frozenCurrentRow = false;
    }
    if (typeof frozenCurrentRow !== 'boolean') {
      frozenCurrentRow = frozenCurrentRow === 'true' ? true : false;
    }
    const virtualRootFrameContext = this.virtualRootFrameContext;
    // è¿åä¸æ¬¡è®¾ç½®çç»æé
    virtualRootFrameContext.params.delete('_DEVKIT_expandRowIds');
    virtualRootFrameContext.params.delete('_DEVKIT_selectedRowId');
    virtualRootFrameContext.uiState.setPropertyValue('__DEVKIT__selectedRow', null);
    const filtersArray = this.parseConditions(filters);
    const parentId = this.getIdToExpand();
    const correctSelectedNode = this.repository.entityCollection.count() === 0;
    const hierarchyType = this.getHierarchyType();
    const repository = TreeRepositoryFactory.getInstance(hierarchyType);

    if (repository === null) {
      return EMPTY;
    }
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const context = {
      frameContext: this.frameContext,
      frozenCurrentRow
    };
    // tslint:disable-next-line: max-line-length
    const query$ = repository.loadFullTree(this.repository, this.hierarchyInfoKey, parentId, virtualPropertyName, fullTreeType, loadType, filtersArray, context);
    return query$.pipe(
      tap(
        (entities: Entity[]) => {
          const selectedRowId = virtualRootFrameContext.params.get('_DEVKIT_selectedRowId');
          // çº æ­£éä¸­èç¹
          if (correctSelectedNode === true) {
            const treeNodeUtil = TreeUtilFactory.getInstance(hierarchyType);
            if (treeNodeUtil !== null) {
              const computedFirstRowId = selectedRowId || treeNodeUtil.selectFirstRootNode(this.bindingData, this.hierarchyInfoKey);
              if (computedFirstRowId) {
                virtualRootFrameContext.uiState.setPropertyValue('__DEVKIT__selectedRow', computedFirstRowId);
              }
            }
          }
          if (frozenCurrentRow && parentId) {
            const currentRowId = this.bindingData.list.currentItem.primaryKeyValue;
            // å»ç»å½åè¡å¯ç¨æ¶åä¸åå³å¿åç«¯è¿åçéä¸­è¡
            virtualRootFrameContext.uiState.setPropertyValue('__DEVKIT__selectedRow', null);
            // å¦æä¸ä¸æ¬¡éä¸­è¡ä¸ºæ¬æ¬¡å è½½æ°æ®ä¸­çä¸æ¡ï¼ååºè¯¥éæ°éä¸­è¯¥è¡
            const containsCurrentRow = entities.find((item) => item.primaryValue === currentRowId);
            if (containsCurrentRow) {
              this.setCurrentId(currentRowId);
            }
            // åæ¥çå½åè¡ä¸å¨å·²ç»å è½½çæ°æ®ä¸­ï¼å¦å±å¼å°ç¬¬ä¸çº§ï¼å°ç¬¬ä¸çº§çæè¡è®¾ä¸ºå½åè¡ï¼å¨é¨æ¶èµ·ï¼å±å¼ç¬¬ä¸çº§
            if (!this.repository.entityCollection.getEntityById(currentRowId) && entities && entities.length > 0) {
              const firstChildId = entities && Array.isArray(entities) && entities.length > 0 && entities[0].primaryValue || null;
              if (firstChildId) {
                this.setCurrentId(firstChildId);
              }
            }
          }
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.loadFailed, error);
        }
      )
    );
  }
  /**
   * è·åææ°å±å¼çèç¹
   */
  public getIdToExpand() {
    const expandNodes = this.virtualRootFrameContext.getParam('TREE_LATEST_EXPANDED_ID') || [];
    const idToExpand = expandNodes.pop();
    this.virtualRootFrameContext.setParam('TREE_LATEST_EXPANDED_ID', expandNodes);
    return idToExpand;
  }

  /**
   * è®¾ç½®ææ°å±å¼çèç¹
   */
  public setIdToExpand(idToExpand: string): void {
    const expandNodes = this.virtualRootFrameContext.getParam('TREE_LATEST_EXPANDED_ID') || [];
    expandNodes.push(idToExpand);
    this.virtualRootFrameContext.setParam('TREE_LATEST_EXPANDED_ID', expandNodes);
  }

  /**
   * è§£æè¿æ»¤æ¡ä»¶
   */
  public parseConditions(conditions?: string): any[] {
    const conditionsString = (!conditions || conditions === '') ? '[]' : conditions;
    return JSON.parse(conditionsString);
  }

  /**
   * æ°å¢åçº§
   */
  public addSibling(id: string): Observable<any> {

    // è®¾è®¡æ¶idçè·åæ¹ä¸ºä»å½ä»¤åæ°ä¸è·åï¼ä½è®¾è®¡æ¶æ²¡æåæ°å¿å¡«æ£æ¥ï¼
    // å¦ææå¼è¡¨åä¿å­äºï¼å³æ´æ°äºææ°çå½ä»¤æä»¶ï¼ï¼ä½æ²¡æéç½®è¯¥åæ°ï¼å¯è½ä¼ä¼ éè¿æ¥ä¸ä¸ªç©ºå¼ï¼
    // ä¸ºäºå¼å®¹æ­¤æåµï¼ä½¿ç¨å½åè¡idä½ä¸ºidçå¼
    id = id ? id : this.bindingData.list.currentId;

    // åæ°æ£æ¥
    if (!id || id === 'undefined') {
      id = '';
    }

    // è®°å½æè¿ä¸æ¬¡ä¿®æ¹çæ°æ®id
    const lastModifiedId = this.bindingData.list.currentId;
    // è·ååçº§æ¹å¼
    const hierarchyType: string = this.getHierarchyType();
    // æ§è¡åæ°
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const repository = TreeRepositoryFactory.getInstance(hierarchyType);
    if (!repository) {
      // éè¯¯çåçº§ç 
      throw new Error(this.languageService['errorHierarchyKey']);
    }
    const result$ = repository.addSibling(this.repository, id);
    return result$.pipe(
      tap(
        () => {
          this.virtualRootFrameContext.setParam('IS_ADD', true);
          this.virtualRootFrameContext.setParam('LAST_MODIFIED_ID', lastModifiedId);
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.addSiblingFailed, error);
        }
      )
    );
  }

  /**
   * æ°å¢ä¸çº§
   */
  public addChild(id: string): Observable<any> {

    // åå åaddSiblingçä¿®æ¹
    id = id ? id : this.bindingData.list.currentId;

    // åæ°æ£æ¥
    if (!id) {
      // è¯·éæ©ç¶èç¹
      this.notifyService.warning(this.languageService['plsSelectParentNode'], { hideTitle: true });
      return empty();
    }

    // è®°å½æè¿ä¸æ¬¡ä¿®æ¹çæ°æ®id
    const lastModifiedId = this.bindingData.list.currentId;
    // è·ååçº§æ¹å¼
    const hierarchyType = this.getHierarchyType();
    // æ§è¡åæ°
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);

    // æ°å¢çæ¶åï¼è¦å±å¼ç¶èç¹
    this.setIdToExpand(id);
    const reloadChild$ = this.reloadByLevel();

    const repository = TreeRepositoryFactory.getInstance(hierarchyType);
    if (!repository) {
      throw new Error(this.languageService['errorHierarchyKey']);
    }
    const addChild$ = repository.addChild(this.repository, id);
    const result$ = reloadChild$.pipe(
      switchMap(() => {
        return addChild$;
      }),
      tap(
        () => {
          this.virtualRootFrameContext.setParam('IS_ADD', true);
          this.virtualRootFrameContext.setParam('LAST_MODIFIED_ID', lastModifiedId);
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.addChildFailed, error);
        }
      )
    );
    return result$;
  }
  /**
   * æ¹éä¿å­
   */
  public save(): Observable<boolean> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'save' });
    }
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const save$ = this.repository.applyChanges();
    const result$ = save$.pipe(
      tap(
        () => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.notifyService.success(this.languageService.saveSuccess, { hideTitle: true });
        },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.multiSaveFailed, error);
        }
      )
    );
    return result$;
  }
  /**
   * å é¤
   */
  public remove(id: string, successMsg?: string): Observable<boolean> {

    // åå åaddSibling
    id = id ? id : this.bindingData.list.currentId;

    // åæ°æ£æ¥
    if (!id) {
      this.notifyService.warning(this.languageService['plsSelectDeleteData'], { hideTitle: true });
      return empty();
    }

    // å­å¨å­èç¹ä¸åè®¸å é¤
    const treeNodesData = this.repository.entityCollection.toJSON();
    const hierarchyType = this.getHierarchyType();
    const treeNodeUtil = TreeUtilFactory.getInstance(hierarchyType);
    if (treeNodeUtil === null) {
      return empty();
    }
    if (treeNodeUtil.hasChildNodes(treeNodesData, this.hierarchyInfoKey, id) === true) {
      this.notifyService.warning(this.languageService['deleteChildFirst'], { hideTitle: true });
      return empty();
    }

    // ç¡®è®¤å é¤
    const action$ = this.messageService.question(this.languageService.confirmDeletion);
    return action$.pipe(
      concatMap(result => {
        if (!result) {
          return empty();
        }

        // è·åå é¤åè¦è®¾ç½®çèç¹id
        const nextNodeId = treeNodeUtil.getNextNodeId(treeNodesData, this.hierarchyInfoKey, id);

        // æ§è¡å é¤
        const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
        const remove$ = this.frameContext.repository.removeById(id);
        return remove$.pipe(
          tap(() => {

            // è®¾ç½®éä¸­èç¹
            treeNodeUtil.selectedNode(this.bindingData, this.hierarchyInfoKey, nextNodeId);

            this.loadingService.hideDelayLoading(loadingTimerId);
            if (successMsg && successMsg.trim()) {
              let showMessage: boolean = true;
              if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
                try {
                  const options = JSON.parse(successMsg);
                  if (options.showMessage === false) {
                    showMessage = false;
                  }
                } catch { }
              }
              if (showMessage !== false) {
                this.notifyService.success(successMsg, { hideTitle: true });
              }
            } else {
              this.notifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
            }
            // this.notifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
          },
            error => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              this.errorService.exception(this.languageService.deleteFailed, error);
            }
          )
        );
      })
    );
  }

  /**
   * åæ¶æ¶æ£æµæªä¿å­è®°å½
   */
  public cancel(): Observable<any> {
    const hasChange$ = DataChangeDetectionService.hasChange(this.frameContext);
    return hasChange$.pipe(
      switchMap((changed: boolean) => {
        if (!changed) {
          return this._cancel();
        } else {
          return this.messageService.question(this.languageService['cancelWithoutSave']).pipe(
            switchMap((ifCancel: boolean) => {
              if (ifCancel === false) {
                return EMPTY;
              }
              return this._cancel();
            })
          );
        }
      })
    );
  }
  /**
   * æé åé¡µä¿¡æ¯
   * @param parentId parentId
   * @returns
   */
  private buildPaginationInfo(parentId: any) {
    const pagination: any = { pageIndex: 0, pageSize: 0 };
    const enableNodePagination = this.frameContext.params.get('enableNodePagination');
    if (!parentId) {
      // ä¸çº§åé¡µ
      const pageSize = this.repository.entityCollection.pageSize || 0;
      const pageIndex = this.repository.entityCollection.pageIndex || 0;
      // å¯ç¨äºä¸çº§åé¡µ
      if (pageSize !== 0) {
        pagination.pageSize = pageSize;
        pagination.pageIndex = pageIndex;
      }
    } else {
      // å¦ææªå¯ç¨èç¹åé¡µæå½åä¸ºé¡¶çº§èç¹å è½½ï¼åä¸å¤çèç¹åé¡µ
      if (enableNodePagination) {
        const nodePageSize = this.frameContext.params.get('nodePageSize') || 0;
        let nodePageIndex = this.frameContext.params.get(`_NODE_${parentId}_PAGE_INDEX_`);
        if (!nodePageIndex) {
          this.frameContext.params.set(`_NODE_${parentId}_PAGE_INDEX_`, 1);
          nodePageIndex = 1;
        }
        pagination.pageIndex = nodePageIndex;
        pagination.pageSize = nodePageSize;
      }
    }
    return pagination;
  }

  /**
   * åæ¶åæ´
   */
  private _cancel(): Observable<any> {
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const cancel$ = this.repository.cancelChanges();
    return cancel$.pipe(
      switchMap(() => {
        const isAdd = this.virtualRootFrameContext.getParam('IS_ADD');
        const lastModifiedId = this.virtualRootFrameContext.getParam('LAST_MODIFIED_ID');
        const currentId = this.bindingData.list.currentId;

        if (isAdd === true) {
          this.repository.entityCollection.removeEntityById(currentId);

          // éç½®ç¼è¾ç¶æ
          this.virtualRootFrameContext.setParam('IS_ADD', false);
          if (lastModifiedId) {
            setTimeout(() => {
              this.bindingData.list.setCurrentId(lastModifiedId, true, true);
            }, 0);
          }
          return of(null);
        } else {
          return this.repository.updateById(currentId);
        }
      }),
      tap(
        () => {
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.errorService.exception(this.languageService.cancelFailed, error);
        }
      )
    );
  }

  /**
   * æ£æ¥æ¯å¦å­å¨ä¸çº§èç¹ï¼åé¨æ¹æ³ï¼è¯·å¿ä½¿ç¨ï¼
   */
  public hasChildNodes(id: string, treeNodesData: any[]): boolean {
    const treeNodeUtil = this.getTreeNodeUtil();
    if (treeNodeUtil.hasChildNodes(treeNodesData, this.hierarchyInfoKey, id) === true) {
      return true;
    }
    return false;
  }

  /**
   * è®¡ç®å é¤åçå½åèç¹idï¼åé¨æ¹æ³ï¼è¯·å¿ä½¿ç¨ï¼
   */
  public getNextNodeIdAfterRemoving(idToRemove: string, treeNodesData: any[]): string {
    const treeNodeUtil = this.getTreeNodeUtil();
    const nextNodeId = treeNodeUtil.getNextNodeId(treeNodesData, this.hierarchyInfoKey, idToRemove);
    return nextNodeId;
  }

  /**
   * è®¾ç½®å é¤åçå½åèç¹èç¹ï¼åé¨æ¹æ³ï¼è¯·å¿ä½¿ç¨ï¼
   */
  public setNextNodeAfterRemoving(nextNodeId: string): void {
    const treeNodeUtil = this.getTreeNodeUtil();
    treeNodeUtil.selectedNode(this.bindingData, this.hierarchyInfoKey, nextNodeId);
  }
  /**
   * è®¾ç½®æ çå½åè¡(ç»å®æ´æ ä½¿ç¨)
   * @param id id
   */
  public setCurrentId(id: string) {
    id = id || this.frameContext.getVirtualRootFrameContext().uiState['__DEVKIT__selectedRow'] || this.bindingData.list.currentItem.primaryKeyValue;
    this.frameContext.bindingData.list.setCurrentId(id, true, true, true);
  }
  /**
   * éä¸­æ çç¬¬ä¸ä¸ªèç¹
   */
  public selectFirstRow() {
    const hierarchyType = this.getHierarchyType();
    const treeNodeUtil = TreeUtilFactory.getInstance(hierarchyType);
    if (treeNodeUtil !== null) {
      treeNodeUtil.selectFirstRootNode(this.bindingData, this.hierarchyInfoKey);
    }
  }
  /**
   * è·åæ èç¹å·¥å·ç±»å®ä¾
   */
  private getTreeNodeUtil(): any {
    const hierarchyType = this.getHierarchyType();
    const treeNodeUtil = TreeUtilFactory.getInstance(hierarchyType);
    if (treeNodeUtil === null) {
      throw new Error(`ä¸æ¯æ${hierarchyType}ç±»åçåçº§`);
    }
    return treeNodeUtil;
  }



  /**
   * è®°å½å è½½ç¶æ
   * @todoï¼å¾å é¤
   */
  private setLoadByLevelState(filters: string, sorts: string) {

    // @todoï¼ä¸´æ¶å¤ç
    this.virtualRootFrameContext.setParam('isLoadTreeByLevel', true);
    this.virtualRootFrameContext.setParam('loadTreeByLevelFilter', filters);
    this.virtualRootFrameContext.setParam('loadTreeByLevelSort', sorts);
  }

  /**
   * å±å¼å½åèç¹
   * @todoï¼å¾å é¤
   */
  private reloadByLevel(): Observable<Entity[]> {
    const isLoadByLevel = this.virtualRootFrameContext.getParam('isLoadTreeByLevel');
    if (isLoadByLevel === true) {
      const filters = this.virtualRootFrameContext.getParam('loadTreeByLevelFilter');
      const sorts = this.virtualRootFrameContext.getParam('loadTreeByLevelSort');
      return this.loadByLevel(filters, sorts);
    }
    return of([]);
  }

  private getHierarchyType(hierarchyInfoKey?: string) {
    const ngObjects = FieldMetadataUtil.getNgObjects(this.repository.entityType);
    const hierarchyInfoNgObjectInfo = ngObjects[this.hierarchyInfoKey || hierarchyInfoKey];
    let hierarchyType = 'path'; // åçº§ç é»è®¤ä¸ºpathï¼å¼å®¹åè¡¨å
    if (hierarchyInfoNgObjectInfo.hasOwnProperty('hierarchyType') && hierarchyInfoNgObjectInfo['hierarchyType'] != null) {
      hierarchyType = hierarchyInfoNgObjectInfo['hierarchyType'] as string;
    }
    if (hierarchyType == null || hierarchyType.length < 1) {
      // 'åçº§ç éç½®ä¿¡æ¯éè¯¯'
      throw new Error(this.languageService['incorrectHierarchyConfig']);
    }
    return hierarchyType;
  }
  /**
   * è·åæ ¹ç»ä»¶æ¶æ¯ç®¡é
   */
  private get messagePipe() {
    if (this.frameContext) {
      const appContext = this.frameContext.getFormAppContext() || null;
      if (appContext) {
        return appContext.messagePipe || null;
      }
    }
    return null;
  }
}
export { TreeDataService };
